import { useSelector } from 'react-redux';
import { TripTypes } from '@model/common';
import { getPath } from '@state/slices/app';
import { getPromoBannerData } from '@state/slices/promo-banner/promoBannerSelectors';
import { PromoBannerContainer as PromoBanner } from '@components/common/banner/promo/PromoBannerContainer';

interface PromoBannerContainerProps {
  promoBannerTripType: TripTypes;
}

export const PromoBannerContainer = ({ promoBannerTripType }: PromoBannerContainerProps) => {
  const promoBannerData = useSelector(getPromoBannerData);
  const statePath = useSelector(getPath);

  if (!promoBannerTripType) return null;
  return <PromoBanner path={statePath} promoBanners={promoBannerData} tripType={promoBannerTripType} />;
};
